import {Sound} from '../../../shared/scripts/Sound'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState'

export class UIStoreMembershipTabsController {
    private readonly monthlyTab: HTMLDivElement
    protected readonly annualTab: HTMLDivElement

    constructor(storeState: UIStoreState) {
        this.monthlyTab = document.getElementById('store_page_membership_monthly_tab') as HTMLDivElement
        this.annualTab = document.getElementById('store_page_membership_annual_tab') as HTMLDivElement

        this.monthlyTab.addEventListener('click', () => {
            Sound.playSound(Sound.SoundType.Click)
            storeState.membershipToggleYearlyActive = false
        })

        this.annualTab.addEventListener('click', () => {
            Sound.playSound(Sound.SoundType.Click)
            storeState.membershipToggleYearlyActive = true
        })
    }

    setTabAnnual(annual: boolean) {
        if(annual) {
            this.monthlyTab.classList.remove('active')
            this.annualTab.classList.add('active')
            return
        }
        this.monthlyTab.classList.add('active')
        this.annualTab.classList.remove('active')
    }
}
